; (function (global, factory) {
    typeof define === 'function' && define.amd ? define('MM/Components/ClientPortal/AccountSettingsWithAddressRequired',['require', "jquery", "MM/Components/Forms/ValidationOptions", "underscoreTemplates", "formsBase", "eventManager", "phoneScript", "phoneUtil", 'MM/Utils/notifier', 'MM/Models/ClientPortal/AccountSettings/RoleSelectionModel', 'MM/Models/ClientPortal/AccountSettings/CountrySelectionModel', "jqueryValidate", "jqueryValidateUnobtrusive", "jqueryUnobtrusiveAjax"], factory) :
    typeof exports === 'object' && typeof module !== typeof void 0 ? module.exports = factory(require('require'), require("jquery"), require("MM/Components/Forms/ValidationOptions"), require("jqueryValidate"), require("jqueryValidateUnobtrusive"), require("eventManager"), require("phoneScript"), require("phoneUtil"), require('MM/Utils/notifier'), require('MM/Models/ClientPortal/AccountSettings/RoleSelectionModel')) :
    console && console.error('Account Settings does not support non-amd script loading.');
}(this/* window */, function (require, $, vo, ut, fb, eventManager, phoneScript, phoneUtil, notifier, roleSelectionModel, countrySelectionModel) {

    function AccountSettingsWithAddressRequired(scope, FormId, User, mapApiKey, ErrorMessage, PasswordResetClickMessagesTransmitting, DeleteAccountUrl, availableRoles, availableProductTypes, signOutUrl, resetPasswordUrl, phoneVerificationUrl, showSuccessMessageOnLoad) {
        this._loadDependencies();

        // TODO: need to refactor: we should pass the context inside of our functions instead
        var that = this;
        Object.defineProperties(this, {
            scope: { writable: !1, configurable: !0, enumerable: !0, value: scope },
            googleMapsApiKey: { writable: !1, configurable: !0, enumerable: !0, value: mapApiKey },
            PasswordResetClickMessagesTransmitting: { enumerable: !0, configurable: !0, writable: !0, value: PasswordResetClickMessagesTransmitting },
            toastMessagesRoot: { writable: !1, configurable: !0, enumerable: !0, value: scope.querySelector('.js-toast-notifications') },
            formEl: { writable: !1, configurable: !0, enumerable: !0, value: scope.querySelector('#' + FormId) },
            btnSubmit: { writable: !0, configurable: !0, enumerable: !0, value: scope.querySelector('.btnSubmit') },
            initialUserData: { writable: !0, configurable: !0, enumerable: !0, value: User },
            availableRoles: { writable: !1, configurable: !0, enumerable: !0, value: availableRoles },
            availableProductTypes: { writable: !1, configurable: !0, enumerable: !0, value: availableProductTypes },
            roleSelectionModel: { writable: !0, configurable: !0, enumerable: !0, value: null },
            signOutUrl: { writable: !1, configurable: !0, enumerable: !0, value: signOutUrl },
            resetPasswordUrl: { writable: !1, configurable: !0, enumerable: !0, value: resetPasswordUrl },
            phoneVerificationUrl: { writable: !1, configurable: !0, enumerable: !0, value: phoneVerificationUrl },
            showSuccessMessageOnLoad: { writable: !1, configurable: !0, enumerable: !0, value: showSuccessMessageOnLoad },
            emailTooltipEl: { writable: !1, configurable: !0, enumerable: !0, value: scope.querySelector('.js-email-tooltip') },
            countrySelectionModel: {writable: !0, configurable:!0, enumerable: !0, value: null},
            defaultCountryForAutocomplete: {writable: !1, configurable:!0, enumerable: !0, value: 'us'},
            autocompleteModel: {writable: !0, configurable: !0, enumerable: !0, value: null }
        });

        var lblArr = this.scope.querySelectorAll('.row .form-group label:not(:has(input))');
        if (lblArr && lblArr.length) {
            [].slice.call(lblArr).forEach(function (lblEl) {
                lblEl.innerHTML = lblEl.innerText.replace(/[*]/ig, '<span>$&</span>')
            });
        }

        this._setupRoleSelectionModel();
        this._setupCountrySelectionModel();
        this._subscribeToFormChange();
        this._setupTooltips();

        var $form = $(`#${FormId}`, scope);
        var $btnSubmit = $('.btnSubmit.btn-primary', scope);
        var $formResult = $(".formResult", scope);
        var formErrResultTemplate = $("#formErrResultTemplate-" + FormId, scope).html();
        var formErrResultLineTemplate = $("#formErrResultLineTemplate-" + FormId, scope).html();
        var $submissionError = $("#submissionError-" + FormId, scope);
        var $confirmEmail = $(".confirm-email-prompt", scope);
        var $btnShowDeleteAccountModal = $(`#${FormId} button#openDeleteAccountModal`, scope)[0];
        var $deleteAccountModal = $('.modal#deleteAccountModal', scope);
        var $deleteAccountButton = $('.btnSubmit.btn-danger#DeleteAccountModalButton', scope)[0];
        var $loaderBackdrop = $('.loader-backdrop.js-loader', scope);

        var loadingText = "Loading...";
        var defaultErrorText = ErrorMessage;
        //var cssSelectorToHideAfterSubmission = args.CssSelectorToHideAfterSubmission;

        $deleteAccountModal.remove();
        $(document.body).append($deleteAccountModal);
        $loaderBackdrop.remove();
        $(document.body).append($loaderBackdrop);

        $(scope).removeAttr("data-ux-module");

        this._resetFormValidation();

        // hide the submission error by default to fix issues where
        // multiple forms are added to one page
        $submissionError.hide();

        if (this.showSuccessMessageOnLoad) {
            this.successMessageAsync();
        }

        if (!this.initialUserData) {
            return;
        }

        this.initialUserData.Verified
            ? $confirmEmail.hide()
            : $confirmEmail.show();

        setInitialValues();

        $("input, textarea", $form.get(0)).on("change keyup countrychange", this.checkFormModified.bind(this));
        this.roleSelectionModel.addOnChangedHandler(this.checkFormModified, this);
        $("#country_dropdown", $form.get(0)).on("click", this.checkFormModified.bind(this));

        $(`#${FormId} .list-option`).on("keypress click", function (e) {
            if ((e.type === "keypress" && e.keyCode === 13) || e.type === "click") {
            var selectedListOption = e.currentTarget;
            var $dropdown = $(selectedListOption).closest(".dropdown-toggle");
            var selectedValue = selectedListOption.dataset.value;
            var $title = $dropdown.find(".score-button-title");
            var title = $title.get(0);

            $title.text(selectedListOption.innerText);
            title.dataset.titleText = selectedListOption.innerText;
            title.dataset.title = selectedListOption.innerText;
            
            $("#User_CountryCode", $form.get(0)).bind("change", function () {
                var $countryNameHiddenField = $(`#User_CountryName`, $form.get(0));
                $countryNameHiddenField.val(selectedListOption.innerText);
            });

            var $hiddenField = $(`#${$dropdown.get(0).dataset.ddlFor}`, $form.get(0));
            if ($hiddenField.length > 0) {
                $hiddenField.val(selectedValue).trigger("change");
                $hiddenField.valid();
            }

            $dropdown.find(".dropdown-menu .list-option").removeClass("active");
                selectedListOption.classList.add("active");
                $dropdown.find("button.score-button").dropdown("toggle");
            }
        });

        $($btnShowDeleteAccountModal).click(function (e) {
            $deleteAccountModal.modal();
        });

        $($deleteAccountButton).click(function (e) {
            $deleteAccountButton.setAttribute("disabled", null);

            $.ajax({
                url: DeleteAccountUrl,
                type: 'POST',
                dataType: "json",
                success: function (result) {
                    if (result.success) {
                        $(document.body).css('pointer-events', 'none');
                        $loaderBackdrop.removeClass('hidden');
                        $deleteAccountModal.modal("hide");
                        that._internalSignOut();

                    } else {
                        $loaderBackdrop.addClass('hidden');
                        $deleteAccountButton.removeAttribute("disabled");
                        that.errorMessageAsync(true);
                    }
                },
                error: function () {
                    $loaderBackdrop.addClass('hidden');
                    $deleteAccountButton.removeAttribute("disabled");
                    that.errorMessageAsync(true);
                }
            });
        });

        $form.submit(function (e) {
            if ($btnSubmit.hasClass("disabled")) {
                return false;
            }
            if ($form.valid()) {
                var submitData = $form.serialize();

                submitForm();
            }
            else {
                $submissionError.show();
            }

            return false;
        });

        $form.on("click", function (e) {
            if ($(this).hasClass("disabled") || $btnSubmit.hasClass("disabled")) {
                e.stopPropagation();
            } else {
                if ($formResult.is(":visible") && $formResult.html().trim() !== "") {
                    $formResult.fadeOut().empty();
                }
            }
        });

        function submitForm() {
            $formResult.fadeOut().empty();
            var defaultText = $btnSubmit.text();
            $btnSubmit.text(loadingText).addClass("disabled");
            var submitData = that._collectFormData(); //$form.serialize();

            $.ajax({
                url: $form.get(0).action,
                type: $form.get(0).method,
                data: submitData,
                dataType: "json",
                traditional: !1,
                success: function (result) {
                    refreshAfterSubmit(defaultText, result.success, result.verifyPhone);
                },
                error: function (xhr) {
                    var result = {};
                    try {
                        result = fb.getAjaxErrorResult(xhr);
                    } catch (e) {
                        console && console.error instanceof Function && console.error(e);
                    } finally {
                        if (result.length && result.length > 1) {
                            ut.renderTemplate($formResult, formErrResultTemplate, { items: result });
                        } else if (result.length && result.length === 1) {
                            ut.renderTemplate($formResult, formErrResultLineTemplate, { item: result[0] });
                        }

                        refreshAfterSubmit(defaultText, false);
                    }
                }
            });
        }

        function refreshAfterSubmit(defaultText, isSuccess, verifyPhone) {
            resetForm();
            $btnSubmit.text(defaultText).removeClass("disabled");
            if (isSuccess) {
                that.initialUserData = that._renewUserData(that.initialUserData, $form.get(0));
                that.checkFormModified();
                that.successMessageAsync();
                if (verifyPhone) {
                    window.location.href = that.phoneVerificationUrl;
                }
                // renew user data
                //if (cssSelectorToHideAfterSubmission) {
                //    $(cssSelectorToHideAfterSubmission).fadeOut();
                //}
                // $form.fadeOut();
                // $formResult.fadeIn(2000, function (e) {
                //     $("html, body").animate({ scrollTop: 0 }, "slow");
                // });
            } else {
                that.errorMessageAsync();

                $formResult.fadeIn().delay(3000).fadeOut(2000);
            }
        }

        function PhoneScriptCallback() {
            var phoneCss = document.createElement('link');
            phoneCss.rel = 'stylesheet';
            phoneCss.type = 'text/css';
            phoneCss.href = 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.16/css/intlTelInput.css';
            document.head.appendChild(phoneCss);
                        
            var userPhoneIti = document.querySelector("#User_PhoneIti");
            var userPhoneNumberField = document.querySelector("#User_PhoneNumber");
            var userPhoneCountryCodeField = document.querySelector("#User_PhoneCountryCode");

            var groupSelector = userPhoneIti.parentElement.closest('div.form-group');
            var spanMsg = groupSelector.querySelector('span[data-valmsg-for="User.PhoneNumber"]');
            var errorMsgDefault = userPhoneNumberField.getAttribute('data-val-required');
            var errorMsgFormat = userPhoneNumberField.getAttribute('data-val-regex');

            var iti = window.intlTelInput(userPhoneIti, {
                utilsScript: phoneUtil,
                preferredCountries: ["us", "ca"],//Optional preffered countries can be pinned on top of the list
                separateDialCode: true,//Optional shows country code next to the country flag                
                formatOnDisplay: "true",//Format the input value during initialisation                
                autoPlaceholder: "aggressive",//Optional shows masked number placeholder instead of b2c's default placeholder
                customPlaceholder: function (selectedCountryPlaceholder, selectedCountryData) {
                    return selectedCountryPlaceholder.replace(/\d/g, "5");
                }
            });

            // set initial values - concatinat phone country code + phone number
            iti.setNumber(userPhoneCountryCodeField.value + userPhoneNumberField.value);

            // a generic way to call trackFieldsSelection() function
            userPhoneIti.dispatchEvent(new Event('change'));

            userPhoneIti.addEventListener('keyup', onPhoneNumberChanged);
            userPhoneIti.addEventListener('change', onPhoneNumberChanged);
            userPhoneIti.addEventListener('countrychange', onCountryChanged);

            //CSS added to properly show dropdown. This should be added using styles not javascript
            userPhoneIti.style.cssText += 'padding-left:80px;';
            var phoneContainer = document.getElementsByClassName("iti iti--allow-dropdown")[0];
            phoneContainer.style.cssText += 'width:100%;margin-bottom: 20px !important;';

            function onCountryChanged() {
                userPhoneIti.dispatchEvent(new Event('change'));
            }

            function onPhoneNumberChanged() {
                if (userPhoneIti.value.trim()) {
                    if (iti.isValidNumber()) {
                        var number = iti.getNumber();
                        var countryCode = '+' + iti.getSelectedCountryData().dialCode;
                        var phoneNumber = iti.getNumber().replace(countryCode, "");
                        userPhoneCountryCodeField.value = countryCode;
                        userPhoneNumberField.value = phoneNumber;

                        groupSelector.classList.remove('has-error');
                        groupSelector.classList.add('has-success');

                        spanMsg.classList.remove('field-validation-error');
                        spanMsg.classList.add('field-validation-valied');
                        spanMsg.innerHTML = '';
                    }
                    else {
                        userPhoneCountryCodeField.value = '';
                        userPhoneNumberField.value = '';

                        groupSelector.classList.remove('has-success');
                        groupSelector.classList.add('has-error');

                        var errorMsg = errorMsgFormat || errorMsgDefault;
                        spanMsg.classList.remove('field-validation-valid');
                        spanMsg.classList.add('field-validation-error');
                        spanMsg.innerHTML = '<span class="text-danger">' + errorMsg + '</span>';
                    }
                }
                else {
                    groupSelector.classList.remove('has-error');
                    groupSelector.classList.remove('has-success');

                    spanMsg.classList.remove('field-validation-error');
                    spanMsg.classList.add('field-validation-valied');
                    spanMsg.innerHTML = '';
                }
            }
        };

        function resetForm() {
            $form.validate().resetForm();
            //$form.get(0).reset();
            $form.find(".has-success, .has-error").removeClass("has-success").removeClass("has-error");
            $form.find(".field-validation-valid").empty();

            $submissionError.hide();
        }

        function setInitialValues() {
            var $role = $("input[type='hidden']#User_Role");
            var $title = $(`.dropdown-toggle[data-ddl-for='User_Role'] .score-button-title`, $form.get(0)).first();

            if (that.initialUserData && that.initialUserData.Role) {
                $role.val(that.initialUserData.Role);
                var $span = $(`.dropdown-toggle[data-ddl-for='User_Role'] ul.dropdown-menu li span[data-value='${that.initialUserData.Role}']`, $form.get(0)).first();

                $title.html($span.text());
            } else {
                const placeholder = $title.prop('data-title');
                $title.html(placeholder);
            }

            PhoneScriptCallback();
        }

        if (this.PasswordResetClickMessagesTransmitting.length) {
            var showResetWindowButton = scope.querySelector(".password-reset");
            if (showResetWindowButton) showResetWindowButton.addEventListener('click', this.resetClickHandler.bind(this));
        }

        this.setupMapPlacesAutocompleteAsync();
    }

    AccountSettingsWithAddressRequired.prototype._setupTooltips = function _setupTooltips() {

        var msgFrag = this._getEmailTooltipNode();
        var template = document.createElement('div');
        template.appendChild(msgFrag);

        var tooltipMessage = template.innerHTML;

        this.scope.querySelector('.js-email-click-handler').addEventListener('click', (function () {
            var $emailFld = $(this.scope.querySelector('#User_Email'));
            var $tooltip = $emailFld.data('bs.tooltip');
            if (!$tooltip) {
                $tooltip = $emailFld.tooltip({
                    html: !0,
                    placement: 'top',
                    title: tooltipMessage,
                    trigger: 'manual'
                })
            }

            $emailFld.tooltip('toggle')

        }).bind(this));

    }

    AccountSettingsWithAddressRequired.prototype._collectFormData = function _collectFormData() {
        var formElements = this.formEl.querySelectorAll('input[type]:not(.form-check-input):not([disabled]), textarea');
        var resultObject = {};
        formElements.forEach(function (el) {
            if (el.getAttribute('name')) {
                resultObject[el.getAttribute('name')] = el.value;
            }
        });

        resultObject[this.roleSelectionModel.scope.getAttribute('data-cp-roles-target')] = this.roleSelectionModel.value.slice(); /* always copy array and not just assign */
        // pull external role of the top level selected roles. needs because of serverside validation
        resultObject[this.roleSelectionModel.scope.getAttribute('data-top-role-target')] = ((this.roleSelectionModel.value.filter(function (role) { return role.ParentRoleId === null && !!role.ExternalProfileRole }) || []).pop() || { 'ExternalProfileRole': null }).ExternalProfileRole;

        return resultObject;
    }

    AccountSettingsWithAddressRequired.prototype.checkFormModified = function checkFormModified() {
        var elementsArr = this.formEl.elements;

        var isChanged = elementsArr.User_FirstName.value !== this.initialUserData.FirstName
            || elementsArr.User_LastName.value !== this.initialUserData.LastName
            || elementsArr.User_Company.value !== this.initialUserData.Company
            || elementsArr.User_Title.value !== this.initialUserData.Title
            || elementsArr.User_Address.value !== this.initialUserData.Address
            || elementsArr.User_Address2.value !== this.initialUserData.Address2
            || elementsArr.User_City.value !== this.initialUserData.City
            || elementsArr.User_StateCode.value !== this.initialUserData.StateCode
            || elementsArr.User_ZipCode.value !== this.initialUserData.ZipCode
            || elementsArr.User_CountryCode.value !== this.initialUserData.CountryCode
            || elementsArr.User_PhoneCountryCode.value !== this.initialUserData.PhoneCountryCode
            || elementsArr.User_PhoneNumber.value !== this.initialUserData.PhoneNumber
            || this._isRolesChanged()

        this.btnSubmit.disabled = !isChanged;

        return isChanged;
    }

    AccountSettingsWithAddressRequired.prototype._isRolesChanged = function _isRolesChanged() {
        if (this.roleSelectionModel.value.length != this.initialUserData.ClientRoles.length) {
            return true;
        }

        // we assume json have the same order of properties
        return JSON.stringify(this.roleSelectionModel.value) != JSON.stringify(this.initialUserData.ClientRoles);
    }

    AccountSettingsWithAddressRequired.prototype.resetClickHandler = function resetClickHandler(e) {
        e.preventDefault();

        if (e.target.disabled) {
            return;
        }

        e.target.disabled = true;

        fetch(this.resetPasswordUrl, { method: 'POST' }).then((function (resp) {
            if (!resp.ok) throw new Error(resp.statusText);

            this.resetPasswordSuccessAsync();
            e.target.disabled = false;
        }).bind(this)).catch((function (err) {
            console && console.error instanceof Function && console.error(err);
            this.resetPasswordErrorAsync();
            e.target.disabled = false;
        }).bind(this));
    }

    // Add Google Map Places autocomplete to Address fields
    AccountSettingsWithAddressRequired.prototype.setupMapPlacesAutocompleteAsync = function setupMapPlacesAutocompleteAsync() {
        // load google maps
        return require(["//maps.googleapis.com/maps/api/js?key=" + this.googleMapsApiKey + "&libraries=places"], (function () {

            // mapping to identify which parts of the address to use
            var componentForm = {
                street_number: 'short_name',
                route: 'long_name',
                // locality: 'long_name', // city
                // administrative_area_level_1: 'long_name', // state
                // postal_code: 'short_name',
                // country: 'long_name'
            };

            // Restrict what kind of data will be shown to the user
            var options = {
                fields: ['address_components'],
                types: ['address'],
                languages: ['en'],
                textarea: true
            };

            // Add Google Map Places autocomplete to each address field found
            this.scope.querySelectorAll('input[data-val-address]').forEach(function (input, index) {
                // This will update the autocomplete to 'chrome-off' if you add it to the
                // input field at the start then Google places will stop working so this 
                // is a workaround to that issue
                input.addEventListener('focus', function (ev) {
                    ev.target.attributes['autocomplete'].value = 'chrome-off';
                });

                var autocomplete = new google.maps.places.Autocomplete(input, options);

                // Add event listener to fill in the address field correctly
                google.maps.event.addListener(autocomplete, 'place_changed', (function (input /* preserved input element*/, autocomplete /* preserved autocomplete entity */) {
                    var place = autocomplete.getPlace();
                    // Clear out the data that will be selected by the user
                    if (input) input.value = '';

                    // Get each component of the address from the place details
                    // and fill the corresponding field on the form.
                    if (place.address_components) {
                        var countryTemp = '';

                        this.countrySelectionModel.selectedCountryCode(place.address_components.reduce(function (acc, addressPart) {
                            if (addressPart.types.some(function (type) { return type === 'country' })) {
                                acc = addressPart['short_name'];
                            }
                            return acc;
                        }, ""));
    
                        this.countrySelectionModel.addressLine1(place.address_components.reduce(function (acc, addressPart) {
                            if (addressPart.types.some(function (type) { return type === 'street_number' || type === 'route'  })) {
                                acc.push(addressPart['short_name']);
                            }
                            return acc;
                        }, []).join(' '));

                        this.countrySelectionModel.city(place.address_components.reduce(function (acc, addressPart) {
                            if (addressPart.types.some(function (type) { return type === 'locality' })) {
                                acc = addressPart['long_name'];
                            }
                            return acc;
                        }, ""));
                        
                        this.countrySelectionModel.stateCode(place.address_components.reduce(function (acc, addressPart) {
                            if (addressPart.types.some(function (type) { return type === 'administrative_area_level_1' })) {
                                acc = addressPart['short_name'];
                            }
                            return acc;
                        }, ""))

                        this.countrySelectionModel.zipCode(place.address_components.reduce(function (acc, addressPart) {
                            if (addressPart.types.some(function (type) { return type === 'postal_code' || type === 'postal_code_suffix' })) {
                                acc.push(addressPart['short_name']);
                            }
                            return acc;
                        }, []).join('-'));

                        // After filling the form with address components from the Autocomplete
                        // prediction, set cursor focus on the second address line to encourage
                        // entry of subpremise information such as apartment, unit, or floor number.
                        var addressLine2El = this.countrySelectionModel.scope.querySelector('.js-address-line-2')
                        if(!!addressLine2El) {
                            addressLine2El.focus();
                        }
                        $(this.countrySelectionModel.scope).find('.col-md-12.form-group:not(.js-phone-number) input, .col-md-12.form-group:not(.js-phone-number) hidden').valid();
                        this.trackFieldsSelection();
                    }
                }).bind(this, input, autocomplete));
            }, this);
        }).bind(this));
    }

    AccountSettingsWithAddressRequired.prototype.trackFieldsSelection = function trackFieldsSelection() {
        var elements = this.formEl.querySelectorAll('input[type]:not([type=\'hidden\']), textarea');
        elements.forEach(function (el) {
            ((!!el.value)
                ? el.classList.add('selection-complete')
                : el.classList.remove('selection-complete'))
        });
    }

    AccountSettingsWithAddressRequired.prototype.successMessageAsync = function successMessage() {
        var msgEl = this._getMessageNode('.js-toast-success');
        if (!msgEl) {
            return Promise.reject();
        }

        return this.notifier.pushSuccessAsync(msgEl);
    }

    AccountSettingsWithAddressRequired.prototype.errorMessageAsync = function errorMessage(deleteMessage) {
        var msgEl = !!deleteMessage ? this._getMessageNode('.delete-account.js-toast-error') : this._getMessageNode('.js-toast-error');
        if (!msgEl) {
            return Promise.reject();
        }

        return this.notifier.pushErrorAsync(msgEl);
    }

    AccountSettingsWithAddressRequired.prototype._getMessageNode = function _getMessageNode(messageSelector) {
        var msgEl = this.toastMessagesRoot.querySelector(messageSelector);
        if (!msgEl) return null;

        var fragment = document.createDocumentFragment();

        // copy children to a fragment, so we can avoid inserting a placeholder into the toast message
        [].forEach.call(msgEl.childNodes, function (el) { fragment.appendChild(el.cloneNode(!0)); }, this);

        return fragment;
    }

    AccountSettingsWithAddressRequired.prototype._getEmailTooltipNode = function _getEmailTooltipNode() {
        var msgEl = this.emailTooltipEl;
        if (!msgEl) return null;

        var fragment = document.createDocumentFragment();

        // copy children to a fragment, so we can avoid inserting a placeholder into the toast message
        [].forEach.call(msgEl.childNodes, function (el) { fragment.appendChild(el.cloneNode(!0)); }, this);

        return fragment;
    }


    AccountSettingsWithAddressRequired.prototype._internalSignOut = function _internalSignOut() {
        fetch(this.signOutUrl, { method: 'POST' }).then(function (resp) {
            if (!resp.ok) throw new Error(resp.statusText);

            window.location = '/';
        }).catch((function (err) {
            console && console.error instanceof Function && console.error(err);
            return this.errorMessage(true);
        }).bind(this));
    }

    AccountSettingsWithAddressRequired.prototype._renewUserData = function _renewUserData(initialUserData, formEl) {
        // copy object
        var result = Object.assign({}, initialUserData);
        var formElsArr = [].slice.call(formEl.querySelectorAll('*[name]'));
        formElsArr.forEach(function (el) {

            var keyName = el.name.replace('User.', '');

            // ignore input if password. 
            if (keyName.toLowerCase() === 'password') return;

            // check if object has data
            if (keyName in result) {
                result[keyName] = el.value;
            }
        });

        result[this.roleSelectionModel.scope.getAttribute('data-cp-roles-target').replace('User.', '')] = JSON.parse(JSON.stringify(this.roleSelectionModel.value)); /* always copy array and not just assign, but since it has nested array - we will need to stringify and parse it again */
        // pull external role of the top level selected roles. needs because of serverside validation
        result[this.roleSelectionModel.scope.getAttribute('data-top-role-target').replace('User.', '')] = ((this.roleSelectionModel.value.filter(function (role) { return role.ParentRoleId === null && !!role.ExternalProfileRole }) || []).pop() || { 'ExternalProfileRole': null }).ExternalProfileRole;

        return result;
    }

    AccountSettingsWithAddressRequired.prototype._subscribeToFormChange = function _subscribeToFormChange() {
        this.formEl.querySelectorAll('input, textarea').forEach(function (el) {
            el.addEventListener('change', this.trackFieldsSelection.bind(this));
        }, this);

        // call it
        this.trackFieldsSelection();
    }

    AccountSettingsWithAddressRequired.prototype._loadDependencies = function _loadDependencies() {
        Object.defineProperty(this, 'notifier', { configurable: !0, enumerable: !1, writable: !1, value: new notifier() });
    }

    AccountSettingsWithAddressRequired.prototype._setupRoleSelectionModel = function _setupRoleSelectionModel() {
        this.roleSelectionModel = new roleSelectionModel(this.scope.querySelector('.js-role-selection'), this.availableRoles, this.availableProductTypes);
        setTimeout((function () { this.roleSelectionModel.value = this.initialUserData.ClientRoles.slice(); }).bind(this), 55 /* truly magic number. If I don't postpone initial data loading, then onChange event doesn't work for multiselect component */);
    }

    AccountSettingsWithAddressRequired.prototype._setupCountrySelectionModel = function setupCountrySelectionModel(){
        this.countrySelectionModel = new countrySelectionModel(this.scope.querySelector('.js-country-dependent'), this.initialUserData);
        // have to reload validation, otherwise new validation messages won't take their place
        this.countrySelectionModel.selectedCountryCode.subscribe(this._resetFormValidation.bind(this));
        // hide validation highlights when country changed
        this.countrySelectionModel.selectedCountryCode.subscribe(this.revalidateCountrySelectorSection.bind(this));   
    }

    AccountSettingsWithAddressRequired.prototype._resetFormValidation = function _resetFormValidation() {
        var $form = $(this.formEl);
        $form.removeData("validator").removeData("unobtrusiveValidation");
        $.validator.setDefaults(vo.getDefaultOptions());
        $.validator.unobtrusive.options = vo.getUnobtrusiveOptions();
        $.validator.unobtrusive.parse($form);

        var settngs = $.data($form[0], 'validator').settings;
        settngs.ignore = "#User_PhoneIti";
    }
    AccountSettingsWithAddressRequired.prototype.revalidateCountrySelectorSection = function revalidateCountrySelectorSection() {
        $(this.countrySelectionModel.scope).find('.col-md-12.form-group:not(.js-phone-number) input, .col-md-12.form-group:not(.js-phone-number) hidden').each(function (i, el) {
            var $formGroup = $(el).closest('.form-group');
            $formGroup.removeClass("has-success").removeClass("has-error");
            $formGroup.find(".field-validation-valid").empty();
            $formGroup.find(".field-validation-error").empty();
        })
    }

    AccountSettingsWithAddressRequired.prototype.resetPasswordSuccessAsync = function resetPasswordSuccess() {
        var msgEl = this._getMessageNode('.reset-password.js-toast-success');
        if (!msgEl) {
            return Promise.reject();
        }

        return this.notifier.pushSuccessAsync(msgEl);
    }

    AccountSettingsWithAddressRequired.prototype.resetPasswordErrorAsync = function resetPasswordError() {
        var msgEl = this._getMessageNode('.reset-password.js-toast-error');
        if (!msgEl) {
            return Promise.reject();
        }

        return this.notifier.pushErrorAsync(msgEl);
    }

    AccountSettingsWithAddressRequired.init = function init(args) {
        if (args.IsExperienceEditorEditing === !0) return null;

        return new AccountSettingsWithAddressRequired(args.scope, args.FormId, args.User, args.GoogleMapsApiKey, args.ErrorMessage, args.PasswordResetClickMessagesTransmitting, args.DeleteAccountUrl, args.AvailableRoles, args.AvailableProductTypes, args.SignOutUrl, args.ResetPasswordUrl, args.PhoneVerificationUrl, args.ShowSuccessMessageOnLoad);
    }

    return AccountSettingsWithAddressRequired;
}));
